import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import DashboardLayout from "./components/DashboardLayout";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Overview from "./pages/Overview";
import Properties from "./pages/Properties";
import Rooms from "./pages/Rooms";
import Tenants from "./pages/Tenants";
import Rent from "./pages/Rent";
import Expenses from "./pages/Expenses";
import Meters from "./pages/Meters";
import Complaints from "./pages/Complaints";
import Reports from "./pages/Reports";
import Documents from "./pages/Documents";
import AuditLog from "./pages/AuditLog";
import TenantLogin from "./pages/TenantLogin";
import TenantHome from "./pages/TenantHome";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Overview />} />
              <Route path="properties" element={<Properties />} />
              <Route path="rooms" element={<Rooms />} />
              <Route path="tenants" element={<Tenants />} />
              <Route path="rent" element={<Rent />} />
              <Route path="expenses" element={<Expenses />} />
              <Route path="meters" element={<Meters />} />
              <Route path="complaints" element={<Complaints />} />
              <Route path="reports" element={<Reports />} />
              <Route path="documents" element={<Documents />} />
              <Route path="audit" element={<AuditLog />} />
            </Route>
            <Route path="/tenant" element={<TenantLogin />} />
            <Route path="/tenant/home" element={<TenantHome />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
